import { TypeSupportArticle, TypeSupportCategory, TypeSupportSubCategory } from 'types/contentful/clinical';
import ContentService from 'utils/contentful/contentfulService';

export const getSupportCategories = async (): Promise<TypeSupportCategory[]> => {
  try {
    const response = ContentService.clients.clinical.getEntries({
      content_type: 'supportCategory',
      limit: 500,
      order: '-sys.createdAt',
    });

    return (await response).items as TypeSupportCategory[];
  } catch (err) {
    throw new Error("Couldn't fetch support categories");
  }
};

export const getSupportSubCategories = async (): Promise<TypeSupportSubCategory[]> => {
  try {
    const response = ContentService.clients.clinical.getEntries({
      content_type: 'supportSubCategory',
      limit: 500,
      order: '-sys.createdAt',
    });

    return (await response).items as TypeSupportSubCategory[];
  } catch {
    throw new Error("Couldn't fetch support subcategories");
  }
};

export const getSupportArticles = async (): Promise<TypeSupportArticle[]> => {
  try {
    const response = ContentService.clients.clinical.getEntries({
      content_type: 'supportArticle',
      limit: 500,
      order: '-sys.createdAt',
    });

    return (await response).items as TypeSupportArticle[];
  } catch (err) {
    throw new Error("Couldn't fetch support articles");
  }
};
